import { cn } from "../lib/utils";
import PADEN from "../lib/beeldmerk-paden.json";

/**
 * Het NovaMund-beeldmerk als assistent-icoon in de chat. J8 van blok J, Frank
 * 18 oktober 2026.
 *
 * GEVOLGD UIT HET LOGO, NIET NAGETEKEND. De eerste versie was een dunne
 * lijntekening uit het hoofd en leek volgens Frank niet op het logo. De vormen
 * komen nu uit `public/logo.png` (`scripts/beeldmerk_uit_logo.py` maakt
 * `lib/beeldmerk-paden.json`): de supernova met haar uitlopers, de N als dikke
 * golf, en de ring als band met de binnenbaan en twee stippen, allemaal gevuld.
 * `backend/tests/test_the_mark_follows_the_logo.py` legt ze terug op het logo.
 * Het oranje is gemeten uit die PNG (`#F88840`).
 *
 * DE RING DRAAIT RUSTIG ZOLANG HET MODEL NADENKT OF STREAMT, en staat stil als
 * het antwoord klaar is. Alleen de ring draait, om het middelpunt van de ellips
 * die op de band is gepast; wie "Beperk beweging" aan heeft staan, ziet hem stil.
 */

export const ORANJE = "#F88840";
export const RINGDUUR = "6s";
export const RINGMIDDEN = PADEN.ringMidden;

export default function Beeldmerk({ actief = false, className, testId = "assistent-beeldmerk" }) {
  const [cx, cy] = RINGMIDDEN;
  return (
    <svg viewBox={PADEN.viewBox} role="img" aria-label="NovaMund" className={cn("h-8 w-8", className)}
         data-testid={testId} data-actief={actief ? "true" : "false"}>
      <path d={PADEN.ster} fill={ORANJE} fillRule="evenodd" data-testid="beeldmerk-ster" />
      <path d={PADEN.n} fill={ORANJE} fillRule="evenodd" data-testid="beeldmerk-n" />
      <g data-testid="beeldmerk-ring"
         className={cn(actief && "animate-spin motion-reduce:animate-none")}
         style={actief ? { animationDuration: RINGDUUR, transformOrigin: `${cx}px ${cy}px`, transformBox: "view-box" } : undefined}>
        <path d={PADEN.ring} fill={ORANJE} fillRule="evenodd" />
      </g>
    </svg>
  );
}
